// 时间戳转日期
export function timestamp2Date(value) {

    const format = 'YYYY-MM-DD HH:mm:ss'

    if (!value) return '';

    // 如果是秒级时间戳，转换为毫秒级
    if (String(value).length === 10) {
        value = Number(value) * 1000;
    }

    const date = new Date(value);

    const formats = {
        YYYY: date.getFullYear(),
        MM: String(date.getMonth() + 1).padStart(2, '0'),
        DD: String(date.getDate()).padStart(2, '0'),
        HH: String(date.getHours()).padStart(2, '0'),
        mm: String(date.getMinutes()).padStart(2, '0'),
        ss: String(date.getSeconds()).padStart(2, '0')
    };

    return format.replace(/YYYY|MM|DD|HH|mm|ss/g, match => formats[match]);
}

// 手机号脱敏
export function encodeMobile(value) {
    if (!value) return '';
    // 使用正则表达式替换手机号中间四位为星号
    return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

// 银行卡号格式化
export function formatBankCard(value) {
    if (!value) return '';
    return value.toString().replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 ');
}

// 银行卡号脱敏
export function  encodeBankCard(value) {
    if (!value || value.length <= 8) return value;
    return value.substring(0, 4) + ' **** **** ' + value.substring(value.length - 4);
}